export default __webpack_public_path__ + "static/media/lt.fce35bd6.webp";